import { Component, OnInit } from '@angular/core';
import { LazySelectableTableComponent } from 'src/app/shared/primeng/abstract-classes/lazy-selectable-table.component';
import { CommitteeMeetingSearchDto } from 'src/app/committees/shared/dto/committee-meeting-search.dto';
import { CommitteeMeetingDto } from 'src/app/committees/shared/dto/committee-meeting.dto';
import { DatagridService, PagedResultGeneric, TranslationService, NotificationService } from 'src/app/shared';
import { CommitteeMeetingService } from 'src/app/committees/shared/committee-meeting.service';
import { MenuItem, SelectItem } from 'primeng/api';
import { NavigationService } from 'src/app/shared/navigation/navigation.service';
import { SecurityElementNames } from 'src/app/shared/auth/constants/security-element-names.service';

@Component({
  selector: 'wl-committee-meetings-search-grid',
  templateUrl: './committee-meetings-search-grid.component.html',
  styleUrls: ['./committee-meetings-search-grid.component.less'],
    standalone: false
})
export class CommitteeMeetingsSearchGridComponent
  extends LazySelectableTableComponent<CommitteeMeetingSearchDto, CommitteeMeetingDto>
  implements OnInit {
  rowMenuItems: Map<number, MenuItem[]> = new Map();
  pagingSizeItems: SelectItem[] = [];
  constructor(
    datagridService: DatagridService,
    public securityElementNames: SecurityElementNames,
    private _committeeMeetingService: CommitteeMeetingService,
    private _translationService: TranslationService,
    private _notificationService: NotificationService,
    private _navigationService: NavigationService
  ) {
    super('MeetingID', datagridService);
  }

  async ngOnInit(): Promise<void> {
    this.pagingSizeItems = [
      {
        label: await this._translationService.getTitlecase('common.page-size.show-20'),
        value: 20,
      },
      {
        label: await this._translationService.getTitlecase('common.page-size.show-100'),
        value: 100,
      },
      {
        label: await this._translationService.getTitlecase('common.page-size.show-all'),
        value: 9999,
      },
    ];
  }

  fetchResults(): Promise<PagedResultGeneric<CommitteeMeetingDto>> {
    return this._committeeMeetingService.search(this.searchParams);
  }

  clearSearch() {
    this.searchParams = new CommitteeMeetingSearchDto();
    this.search();
  }

  actionItemsForMeeting(meeting: CommitteeMeetingDto): MenuItem[] {
    if (!this.rowMenuItems.has(meeting.MeetingID)) {
      this.rowMenuItems.set(meeting.MeetingID, [
        {
          label: this._translationService.getInstantTitlecase('common.edit'),
          command: () => this.editMeeting(meeting),
        },
        {
          label: this._translationService.getInstantTitlecase('common.delete'),
          command: () => this.deleteMeeting(meeting),
        },
      ]);
    }
    return this.rowMenuItems.get(meeting.MeetingID);
  }

  editMeeting(meeting: CommitteeMeetingDto) {
    this._navigationService.navigateToCommitteeMeetingEdit(meeting.CommitteeID, meeting.MeetingID);
  }

  deleteMeeting(meeting: CommitteeMeetingDto) {
    this._committeeMeetingService
      .delete(meeting.MeetingID)
      .then(() => {
        this.search();
      })
      .catch((err) => {
        this._notificationService.httpError(err);
      });
  }

  pageSizeChanged() {
    this.searchParams.PageNumber = 1;
    this.search();
  }
}
